import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=7f131c34&scoped=true&"
import script from "./operate.vue?vue&type=script&lang=js&"
export * from "./operate.vue?vue&type=script&lang=js&"
import style0 from "./operate.vue?vue&type=style&index=0&id=7f131c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f131c34",
  null
  
)

export default component.exports